import styled from 'styled-components';
import { MIN_WIDTH, MAX_WIDTH } from 'constants/buttonConstants';

export const BaseButton = styled.button`
  border-radius: 4px;
  cursor: pointer;
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  height: 40px;
  max-width: ${MAX_WIDTH}px;
  min-width: ${MIN_WIDTH}px;
  padding: 8px 16px;
  text-align: center;
`;

export const InvisibleButton = styled(BaseButton)`
  height: auto; 
  max-width: auto;
  min-width: auto;
  padding: 0;
  border: none;
  background: none; 
  &:focus {
    outline: none; 
  }
`;

export default BaseButton;
